import { resolveApiUrl } from '../api/api';

export const bookingAccessHeaders = (token: string, requestPath: string) => {
  const requestUrl = new URL(resolveApiUrl(requestPath), window.location.href);
  if (requestUrl.protocol !== 'https:') {
    throw new Error('Приватний доступ до бронювання доступний лише через захищене HTTPS-з’єднання.');
  }
  return { 'X-Booking-Access': token };
};
